import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { ToastContext } from "../../../../hooks/context";
import { checkoutwithCard } from "../../../../services/sales-point";
import { cleanObject } from "../../../../helpers";
import { useParams } from "react-router-dom";
import { useGetInfo } from "../../../../hooks/useGetInfo";
import { useSelector } from "react-redux";
const CardPaymentLogic = ({ selectBank, closePaymentSession }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const orderId = queryParams.get("order_id");
  const triggerToast = useContext(ToastContext);
  const [selectedCardPayments, setSelectedCardPayments] = useState("");
  const [isEnabled, setIsEnabled] = useState(true);
  const { store_id } = useParams();
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const supportRavenPayment =
    storeDetails?.support_raven_payment_on_checkout_flow;
  const { raven } = useSelector((state) => state.paymentsReducer);

  const { isLoading: loadingExternal, mutate: paidExternally } = useMutation(
    (data) => checkoutwithCard(data),
  );

  const payViaExternal = () => {
    paidExternally(
      cleanObject({
        order_id: orderId,
        payment_provider: raven?.paymentType || null,
        payment_reference: raven?.rrn || null,
        ledger_account_id: selectBank,
      }),
      {
        onSuccess: () => {
          triggerToast("Payment linked successful", "success");
          closePaymentSession();
        },
      },
    );
  };

  useEffect(() => {
    if (raven?.hasCompletedPayment) payViaExternal();
  }, [raven?.hasCompletedPayment]);

  return {
    selectedCardPayments,
    isEnabled,
    supportRavenPayment,
    loadingExternal,
    setSelectedCardPayments,
    setIsEnabled,
    payViaExternal,
  };
};
export default CardPaymentLogic;
